import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { createSupportLaunchCode } from "../services/supportTestSessionService";
import { getSupportBuilderLaunchError } from "./supportBuilderLaunchError";

let pendingBuilderLaunch: ReturnType<typeof createSupportLaunchCode> | null = null;

export default function SupportBuilderRedirectPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const entryPath = searchParams.get("entry_path") || "";
    if (!entryPath.startsWith("/builder/") || entryPath.startsWith("//")) {
      setError("La ruta del editor no es válida.");
      return;
    }

    pendingBuilderLaunch ||= createSupportLaunchCode(entryPath, "BUILDER");
    void pendingBuilderLaunch
      .then(({ launchUrl }) => window.location.replace(launchUrl))
      .catch((requestError) => {
        pendingBuilderLaunch = null;
        console.error("No se pudo abrir el builder con la sesión delegada:", requestError);
        setError(getSupportBuilderLaunchError(requestError));
      });
  }, [searchParams]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-6">
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="mb-3 text-lg font-bold text-slate-900">
          {error ? "No se pudo abrir el editor" : "Abriendo el editor seguro…"}
        </h1>
        <p className="text-sm leading-6 text-slate-600">
          {error || "Estamos creando un enlace de un solo uso sin exponer la sesión en la URL."}
        </p>
      </div>
    </div>
  );
}
